// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3_ELj","header":"MessagesList_header__2tJ55","chat":"MessagesList_chat__3pgCl"};